import http from './http';
import {METADATA_BASE} from './paths';
import {withPerm} from './perm';

// 용어데이터 목록 조회
export const getTermDataList = withPerm(async () => {
  const response = await http.get(`${METADATA_BASE}/trmData`);
  return response.data;
}, 'GET', `${METADATA_BASE}/trmData`);

// 용어데이터 상세 조회
export const getTermData = withPerm(async (trmDataId) => {
  const response = await http.get(`${METADATA_BASE}/trmData/${trmDataId}`);
  return response.data;
}, 'GET', `${METADATA_BASE}/trmData/{trmDataId}`);

// 용어데이터 생성
export const createTermData = withPerm(async (termData) => {
  const response = await http.post(`${METADATA_BASE}/trmData`, termData);
  return response.data;
}, 'POST', `${METADATA_BASE}/trmData`);

// 용어데이터 일괄 생성
export const createTermDataBatch = withPerm(async (termDataList) => {
  const response = await http.post(`${METADATA_BASE}/trmData/batch`, termDataList);
  return response.data;
}, 'POST', `${METADATA_BASE}/trmData/batch`);

// 용어데이터 삭제 (단건) - 백엔드와 일치
export const deleteTermData = withPerm(async (trmDataId) => {
  const response = await http.delete(`${METADATA_BASE}/trmData/${trmDataId}`);
  return response.data;
}, 'DELETE', `${METADATA_BASE}/trmData/{trmDataId}`);

// 용어데이터 일괄 삭제 (백엔드 batch 엔드포인트 존재)
export const deleteTermDataBatch = withPerm(async (trmDataIdList) => {
  const response = await http.delete(`${METADATA_BASE}/trmData/delete/batch`, { data: trmDataIdList });
  return response.data;
}, 'DELETE', `${METADATA_BASE}/trmData/delete/batch`);

// 용어데이터 검색
export const searchTermData = withPerm(async (searchParams) => {
  const response = await http.get(`${METADATA_BASE}/trmData/search`, { params: searchParams });
  return response.data;
}, 'GET', `${METADATA_BASE}/trmData/search`);
